/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShopPerformanceDimensionRow } from './ShopPerformanceDimensionRow';
import {
    ShopPerformanceDimensionRowFromJSON,
    ShopPerformanceDimensionRowFromJSONTyped,
    ShopPerformanceDimensionRowToJSON,
    ShopPerformanceDimensionRowToJSONTyped,
} from './ShopPerformanceDimensionRow';

/**
 * 
 * @export
 * @interface ShopPerformanceDimensionData
 */
export interface ShopPerformanceDimensionData {
    /**
     * 
     * @type {string}
     * @memberof ShopPerformanceDimensionData
     */
    dimension?: string;
    /**
     * 
     * @type {Array<ShopPerformanceDimensionRow>}
     * @memberof ShopPerformanceDimensionData
     */
    rows?: Array<ShopPerformanceDimensionRow>;
}

/**
 * Check if a given object implements the ShopPerformanceDimensionData interface.
 */
export function instanceOfShopPerformanceDimensionData(value: object): value is ShopPerformanceDimensionData {
    return true;
}

export function ShopPerformanceDimensionDataFromJSON(json: any): ShopPerformanceDimensionData {
    return ShopPerformanceDimensionDataFromJSONTyped(json, false);
}

export function ShopPerformanceDimensionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopPerformanceDimensionData {
    if (json == null) {
        return json;
    }
    return {
        
        'dimension': json['dimension'] == null ? undefined : json['dimension'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(ShopPerformanceDimensionRowFromJSON)),
    };
}

export function ShopPerformanceDimensionDataToJSON(json: any): ShopPerformanceDimensionData {
    return ShopPerformanceDimensionDataToJSONTyped(json, false);
}

export function ShopPerformanceDimensionDataToJSONTyped(value?: ShopPerformanceDimensionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dimension': value['dimension'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(ShopPerformanceDimensionRowToJSON)),
    };
}

